module.exports = __webpack_public_path__ + "logo-orkla-black-3ecd2e0902e3f5d589cea489f2da6457.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/logo-orkla-black.svg
// module id = 56
// module chunks = 0